import {RESET_STORE} from "constants/ActionTypes";

export const resetStore = () => {
  return {
    type: RESET_STORE,
  }
};
